<svelte:head>
  <title>Geotoy Docs + Reference</title>
</svelte:head>

<h2>Geotoy Docs + Reference</h2>

<p>
  Geotoy is a tool for creating and sharing 3D scenes and models created using <b>Geoscript</b>
  - a DSL for generating and manipulating 3D meshes.
</p>
<p>
  It's inspired heavily by <a href="https://shadertoy.com">Shadertoy</a>
  , but focuses on geometry rather than on shaders.
</p>

<ul>
  <li><a href="/geoscript/docs/quickstart">Geoscript Language Quickstart</a></li>
  <li><a href="https://www.youtube.com/watch?v=CtbXFP4FGpw">Geotoy Intro + Overview (Youtube)</a></li>
  <li><a href="/geoscript/docs">Geoscript Builtin Function Reference</a></li>
  <li><a href="/geotoy/docs/editor">Editor Shortcuts + Reference</a></li>
</ul>
